import React, { FunctionComponent } from 'react';

import { usePromiseTracker } from 'react-promise-tracker';

import { OverlayMode, OverlayDisplay } from 'core/overlay/OverlayDisplay';

export { OverlayMode } from 'core/overlay/OverlayDisplay';

interface Props {
    area: string;
    className?: string;
    mode?: OverlayMode;
}

export const Overlay: FunctionComponent<Props> = ({ area, className, mode = OverlayMode.Spinner }) => {
    const { promiseInProgress } = usePromiseTracker({ area });

    if (promiseInProgress === true) {
        return <OverlayDisplay className={className} mode={mode} />;
    }

    return null;
};
